import React from "react";
import "./index.scss";
import {string} from "prop-types";
import Title from "features/components/title";
import Text from "features/components/text";

export const RecommendationItem = (props) => {
    const {avatar, content, name, extra} = props;
    return <div className={"recommendation-item"}>
        <div className={"content"}>
            <div className={`image ${!!avatar ? "has-image" : ""}`}>
                {!!avatar && <img src={avatar} alt={"logo"}/>}
            </div>
            <div className={"data"}>
                <div className={"name"}>
                    <Title size={18}>{name}</Title>
                    <Text size={14} color={"light"}>{extra}</Text>
                </div>
                <Text size={16}>{content}</Text>
            </div>
        </div>
        <div className={"buttons"}>
            {props.children}
        </div>
    </div>
}
RecommendationItem.propTypes = {
    content: string.isRequired,
    name: string.isRequired,
    avatar: string.isRequired,
    extra: string
}